import axios from 'axios';
import authenStatusModel from '../models/authenStatus';

export default class auth {
	constructor(component) {
		this.component = component;
	}

	isLoggedIn() {
		axios.get('/auth/status')
			.then(res => {
				console.log('12: Response from /auth/status');
				console.log(res.data);
				let authenStatus = new authenStatusModel();
				authenStatus.isLoggedIn = res.data.isLoggedIn;
				authenStatus.loggedInSystem = res.data.loggedInSystem;
				authenStatus.user = res.data.user;
				authenStatus.requireKyc = res.data.requireKyc;

				this.component.setState({
					authenStatus: authenStatus,
					dataLoaded: true,
				});
			});
	}

	logout(loggedInSystem) {
		axios.get('/auth/logout')
			.then(res => {
				// window.location.href = '/' + loggedInSystem + '/login';
				window.location.href = 'https://www.google.com/accounts/Logout?continue=https://appengine.google.com/_ah/logout?continue=https://dd.ku.ac.th/' 
					+ loggedInSystem + '/login';
			});
	}
}